import { entities } from "@global";
import Vector from "victor";
function navigateDependencyTree(rootBehavior, behaviorSet) {
    behaviorSet.add(rootBehavior);
    const root = rootBehavior;
    root.dependencies &&
        root.dependencies.forEach((dep) => {
            navigateDependencyTree(dep, behaviorSet);
        });
}
export function buildEntity({ behaviors, draw, update, init, name, }) {
    return (x, y, ...initParams) => {
        const behaviorSet = new Set();
        for (const behavior of behaviors) {
            navigateDependencyTree(behavior, behaviorSet);
        }
        const entity = {
            behaviors: Array.from(behaviorSet),
            position: new Vector(x, y),
            name,
            get x() {
                return this.position.x;
            },
            get y() {
                return this.position.y;
            },
            set x(x) {
                this.position.x = x;
            },
            set y(y) {
                this.position.y = y;
            },
            update(dt) {
                entity.behaviors.forEach((behavior) => {
                    behavior.update(entity, dt);
                });
                if (update) {
                    update(entity, dt);
                }
            },
            draw(context) {
                if (draw) {
                    draw(entity, context);
                }
            },
            init() {
                if (init) {
                    init(entity, ...initParams);
                }
                entity.behaviors.forEach((behavior) => {
                    behavior.init(entity);
                });
            },
            hasBehavior(behavior) {
                return this.behaviors.includes(behavior);
            },
            remove() {
                entity.behaviors.forEach((behavior) => {
                    behavior.cleanup(entity);
                });
                entities.splice(entities.indexOf(entity), 1);
            },
        };
        behaviorSet.forEach((behavior) => {
            Object.assign(entity, behavior.properties());
            return entity;
        });
        entity.init();
        return entity;
    };
}
